import { marked } from 'marked';

export default function(config) {
  marked.setOptions({
    breaks: true
  });
};
